import { rosterAPI } from '@/providers/apis/roster/roster';
import { copy } from '@/utils/cohort';
import { isAPICatchError } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'course-details',
})

export default class CourseDetails extends Vue {


    // ------------------------------------------------------------------------
    // Properties
    @Prop()
    private activeRoster: any;

    @Prop({default: false})
    private showSourceId: any;

    private courseList: any = [];

    private isLoading: boolean = false;

    private tableFields: any = [
        // {
        //     key: 'sourcedId',
        //     label: 'Sourced Id',
        // },
        {
            key: 'title',
            label: 'Title',
        },
        {
            key: 'syncStatusCode',
            label: 'Status',
        },
        {
            key: 'syncStatusMessage.message',
            label: 'Errors',
        },
        {
            key: 'sourcedId',
            label: 'Sourced Id',
        },
    ];

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;

    public get filteredItemList() {
        const tableFields = copy(this.tableFields);
        return tableFields.filter((item: any) => {
            if (this.showSourceId) {
                return tableFields;
            } else {
               return item.key !== 'sourcedId';
            }
        });
    }

    // ---------------------------------------------------------------------------------
    // Hooks

    private created() {
        this.isLoading = true;
        if (!this.activeRoster.showError) {
            const errorIndex = this.tableFields.findIndex((item: any) => item.label === 'Errors');
            if (errorIndex !== -1) {
                this.tableFields.splice(errorIndex, 1);
            }
        }
        this.fetchClasslist();
    }

    // ---------------------------------------------------------------------------------
    // Actions

    private onSelectPage(item: any) {
        if (this.courseList.length < item * this.pageLimit) {
            this.isLoading = true;
            this.currentPage = item;
            this.offset = (item - 1) * this.pageLimit;
            this.fetchClasslist();
        }

    }

    // ------------------------------------------------------------------------------
    // Methods

    private fetchClasslist() {
        const params = {
            zipId: this.activeRoster.id,
            offset: this.offset,
            limit: this.limit,
            is_required_sync: this.activeRoster.showError,
        };

        rosterAPI.getCoursesDetails(params).then((courseList) => {
            this.isLoading = false;
            if (!isAPICatchError(courseList)) {
                this.courseList = courseList.courses;
                this.totalLength = courseList.totalCoursesCount;
            }
        });
    }

}
